
export enum StatisticsAlertOption {
    Never = 'Never',
    Weekly = 'Weekly',
}
